import { gql } from '@apollo/client'

export const fetchTranscriptQuery = gql`
  query FetchTranscript($threadUUID: String!) {
    transcript(threadUUID: $threadUUID) {
      thread {
        id
        addressThem
        pmItemKeyJsons
        leasingTask {
          id
        }
        relatedThreads {
          id
          taskName
          messageType
          lastInboundMessageTime
          uuid
        }
        contactThem {
          firstName
          lastName
          addressPhone
          addressEmail
        }
      }
      timezone
      showings {
        id
        leasingTaskId
        timeStart
      }
      showingContactHistories {
        showingId
        confirmationStatus
        timeUpdated
      }
      hidePhotoId
      messages {
        id
        timeCreated
        isInbound
        messageType
        messageStatus
        classification
        routedTo
        leasingAttributionSource
        leasingAttributionSourceDisplayName
        addressFrom
        addressTo
        censoredShortBody
        censoredTranslatedShortBody
        isIlsInbound
        mediaUrl
      }
    }
  }
`
